import React from "react";

const ChallengeItem = ({ title, description, isLast = false }) => (
  <div className="flex relative pl-8 pb-16">
    <div className="absolute left-0 top-[13px] bottom-0 w-2">
      <div className="absolute top-0 w-2 h-2 bg-gray-900 border border-gray-900"></div>
      {!isLast && (
        <div
          className="absolute left-[3.5px] top-[8px] w-px bg-gray-400"
          style={{ height: 'calc(100% - 0px)' }}
        ></div>
      )}
    </div>
    <div className="flex-grow">
      <p
        className="
          text-current mb-1 w-full
          font-uber text-[18px] font-medium leading-normal
          transition duration-200 ease-in-out
        "
      >
        {title}
      </p>
      <p
        className="
          text-gray-600 
          font-uber text-base font-normal leading-normal
        "
      >
        {description}
      </p>
    </div>
  </div>
);


export default function Achievements() {
  return (
    <section className="relative w-full overflow-hidden bg-white text-gray-900">
      <div className="mx-auto max-w-6xl py-12 px-4 sm:px-4">

        <div className="mb-12">
          <h1
            className="
              w-full
              font-uber text-[28px] font-bold leading-[36px] text-current
              sm:text-[32px] sm:leading-[40px]
              xl-custom:text-[36px] xl-custom:leading-[44px]
              transition duration-200 ease-in-out
            "
          >
            Achievements
          </h1> 
        </div>

        <div className="flex flex-col xl-custom:flex-row gap-12 mb-12 xl-custom:items-start">
          <div className="w-full xl-custom:w-1/2 flex items-stretch justify-center order-1 xl-custom:order-2">
            <div className="w-full flex items-center justify-center rounded-lg p-4 sm:p-8">
              <img
                src="/uploads/CaseStudy/Asset 94.svg"
                className="w-full"
                alt="Challenge visualization placeholder" 
              />
            </div>
          </div>

          <div className="w-full xl-custom:w-1/2 order-2 xl-custom:order-1">
            <ChallengeItem title="Breakthrough in Engagement" description="Successfully implemented playables, achieving a remarkable surge in user interactions and prolonged engagement time." />
            <ChallengeItem title="Exceptional Customer Satisfaction" description="Delivered highly personalized and interactive experiences, resulting in increase in engagement rates and strong offer redemptions." />
            <ChallengeItem title="Data-Driven Success" description="Leveraged deep analytics from user interactions to optimize future campaigns, boost conversions, and refine content personalization strategies." />
            <ChallengeItem title="Scalable Impact" description="Established a versatile and high-performing framework for deploying playables seamlessly across multiple digital platforms, ensuring long-term growth and adaptability." isLast={true} />
          </div>

        </div>


      </div>
    </section>
  );
}